import PowerBiPrompt from "emun.report/powerbi-prompt";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";

export default class PowerBiReportsController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.query = new AutoQuery({
			url: "QueryPowerBIReports.json",
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "Name",
			sortOptions: {
				"Name": "Name: A to Z",
				"-Name": "Name: Z to A"
			},
			autoLoad: true,
			onLoaded: function (args) {
				$ctrl.reports = args.results;
			},
			pageSize: 1000
		});
		$ctrl.$on("powerBiSaved", () => $ctrl.query.load(true));
		$ctrl.bus = new ServiceBus();
	}
	addReport() {
		const $ctrl = this;
		PowerBiPrompt.open({ report: "", reportId: "" });
	}

	editReport(report) {
		const $ctrl = this;
		PowerBiPrompt.open({ report: report, reportId: report.id });
	}

	deleteReport(report) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete " + report.name, "Delete PowerBI Report?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeletePowerBIReport.json", report)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
	viewReport(report) {
		return location.href = "#/powerbi?reportId=" + report.id;
	}
}
